import { Settings } from "../../../Settings";
import TimeFormatter from "../../../util/TimeFormatter";
import Totals from "../../crew/Totals";
import Values from "../../value/Values";
import SkillNode from "../SkillNode";

export default class OfflineBonusSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {Values} values
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, values) {
        super(id, 'Offline +' + Settings.offline.minutesPerUpgrade + ' min', null, totals, 
            iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
    }

    /**
     * @returns {string}
     */
    getDescription() {

        const minutes = Settings.offline.defaultOfflineMinutes + (this.values.offlineTimeUpgrades.getValue() * Settings.offline.minutesPerUpgrade);
        const millis = minutes * 60 * 1000;

        return 'Offline Time: ' + TimeFormatter.formatElapsedTime(millis);
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.applyUpgrade();
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        this.applyUpgrade();
        super.onPurchaseFromSave();
    }

    /**
     * @private
     */
    applyUpgrade() {
        this.values.offlineTimeUpgrades.incrementValue(1);
    }

}